export default "__VITE_ASSET__tig1Djra__"